export default __webpack_public_path__ + "static/media/right-arrow.aaf3dd35.svg";